import { Component, Input, OnDestroy, OnInit } from '@angular/core'
import { Subscription } from 'rxjs'
import { AEMChunk } from 'src/app/services/AEM/aem-chunk.model'
import { CentralContentService } from 'src/app/services/content/central-content.service'
@Component({
  selector: 'balanced-risk',
  templateUrl: './balanced-risk.component.html',
  styleUrls: ['./balanced-risk.component.scss'],
})
export class BalancedRiskComponent implements OnInit, OnDestroy {
  @Input() shortName: string
  //AEM Variables
  balancedRiskStrategies: AEMChunk
  longShortCommodities: AEMChunk
  longShortEquities: AEMChunk
  longShortEquityIndex: AEMChunk
  longShortForeignExchange: AEMChunk
  fixedIncome: AEMChunk
  mergerArbitrage: AEMChunk
  aemContentSub: Subscription
  //chart
  chartId = 'assetAllocationPieChart3'
  tableId = 'assetAllocationTable3'
  chartAndTable = []
  selectPathData = undefined
  constructor(private readonly centralContentService: CentralContentService) {
    // do nothing.
  }

  ngOnInit() {
    // window.addEventListener("load", function(){
      setTimeout(function () {
        const element = document.getElementById('accordion-item-0');
        /* istanbul ignore next */
        if (element) {
          element.click();
        }
        // eslint-disable-next-line @typescript-eslint/no-magic-numbers
      }, 100);
    // });
    this.aemContentSub = this.centralContentService.aemContent$.subscribe(
      (content) => {
        this.parseAEMContent(content)
      },
    )
    this.chartAndTable = [
      {
        id: 'Communication Services0',
        name: 'Long/Short Commodities',
        value: '5',
        benchmark: '5.30',
        weight: null,
        color: '#007873',
        description: this.longShortCommodities.contentValue,
        aemSource: this.longShortCommodities.isAEM,
      },
      {
        id: 'Consumer Discretionary1',
        name: 'Long/Short Equities',
        value: '5',
        benchmark: '15.10',
        weight: null,
        color: '#1BA39C',
        description: this.longShortEquities.contentValue,
        aemSource: this.longShortEquities.isAEM,
      },
      {
        id: 'Consumer Staples2',
        name: 'Long/Short Equity Index',
        value: '5',
        benchmark: '0.80',
        weight: null,
        color: '#8DD1CE',
        description: this.longShortEquityIndex.contentValue,
        aemSource: this.longShortEquityIndex.isAEM,
      },
      {
        id: 'Energy3',
        name: 'Long/Short Foreign Exchange',
        value: '5',
        benchmark: '7.70',
        weight: null,
        color: '#BFDDDC',
        description: this.longShortForeignExchange.contentValue,
        aemSource: this.longShortForeignExchange.isAEM,
      },
      {
        id: 'Financials4',
        name: 'Fixed Income',
        value: '5',
        benchmark: '11.00',
        weight: null,
        color: '#F29440',
        description: this.fixedIncome.contentValue,
        aemSource: this.fixedIncome.isAEM,
      },
      {
        id: 'Health Care5',
        name: 'Merger Arbitrage',
        value: '5',
        benchmark: '13.00',
        weight: null,
        color: '#670026',
        description: this.mergerArbitrage.contentValue,
        aemSource: this.mergerArbitrage.isAEM,
      },
    ]
  }

  parseAEMContent(content) {
    this.balancedRiskStrategies = this.centralContentService.getContentByBody(
      'fund_definitions_alternative_strategies_balanced_risk_strategies',
      content,
    )
    this.longShortCommodities = this.centralContentService.getContentByBody(
      'fund_definitions_alternative_strategies_long_short_commodities',
      content,
    )
    this.longShortEquities = this.centralContentService.getContentByBody(
      'fund_definitions_alternative_strategies_long_short_equities',
      content,
    )
    this.longShortEquityIndex = this.centralContentService.getContentByBody(
      'fund_definitions_alternative_strategies_long_short_equity_index',
      content,
    )
    this.longShortForeignExchange = this.centralContentService.getContentByBody(
      'fund_definitions_alternative_strategies_long_short_foreign_exchange',
      content,
    )
    this.fixedIncome = this.centralContentService.getContentByBody(
      'fund_definitions_alternative_strategies_fixed_income',
      content,
    )
    this.mergerArbitrage = this.centralContentService.getContentByBody(
      'fund_definitions_alternative_strategies_merger_arbitrage',
      content,
    )
  }

  ngOnChanges() {
    // do nothing.
  }
  selectPath(rowId) {
    this.selectPathData = {
      chartId: this.chartId,
      tableId: this.tableId,
      trId: rowId,
    }
  }
  ngOnDestroy(): void {
    this.aemContentSub.unsubscribe()
  }
}
